export const titleBlue = '#415daa'
export const titleGrey = '#3d3d3d'
export const paragraphGrey = '#c0c0c0'
export const linkGreen = '#4faa77'
export const maroon = '#9d1b1d'
export const midBlue = '#415daa'


// WEBPACK FOOTER //
// ./src/colors.js